module.exports = __webpack_public_path__ + "img/icon_project05.d9ebf0f0.png";